<!-- // This component is also used for View Voucher buttons within Itinerary Bricks // -->
<template>
  <b-modal
    ref="additional-document-modal-ref"
    hide-footer
    hide-header
    :title="payload.title"
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">
          {{ supplier }}
        </h5>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div class="vtd-modal-body">
        <p style="text-align: left">
          Here you will find additional documents which have been issued by the
          supplier.
        </p>
        <p>
          Please ensure you read through each document carefully as they contain
          important information relating to your trip. This may include transfer
          information or joining instructions, itinerary details and other
          essential information.
        </p>
        <div v-if="payload.flag === 'multi'">
          <div
            class="row align-items-center mb-3"
            v-for="filename in filenames"
            :key="filename"
          >
            <div class="col-md-1 vtd-py-2">Name:</div>
            <div class="col-md-8 text-none vtd-py-2">
              <strong class="ng-binding">{{
                filename | replaceFilename
              }}</strong>
            </div>
            <div class="col-md-3">
              <a
                target="_blank"
                :href="
                  'https://www.trailfinders.' +
                  returnSite +
                  '/tourdoc/bybookno/' +
                  bookingNumber +
                  '/' +
                  filename
                "
              >
                <button
                  class="btn btn-support btn-consultant m-auto btn-secondary"
                >
                  <i class="material-icons">&#xE880;</i>View Document
                </button>
              </a>
            </div>
          </div>
        </div>
        <div v-if="payload.flag === 'additional'">
          <div
            class="row align-items-center mb-1"
            v-for="group in additionalSupDocGroups"
            :key="group.shortname"
          >
            <div class="column col-12 text-none">
              <!-- Showing the name of each additional document group -->
              <div class="mb-2">
                <strong class="ng-binding">{{ group.shortname }}</strong>
              </div>
              <div
                class="row align-items-center justify-content-between mb-3 mx-0"
                v-for="index in group.doclist"
                :key="index"
              >
                <p class="col-md-9 m-0 p-0">
                  {{ filenames[Number(index)] | replaceFilename }}
                </p>
                <div class="col-md-3 justify-self-end">
                  <a
                    target="_blank"
                    :href="
                      'https://www.trailfinders.' +
                      returnSite +
                      '/tourdoc/bybookno/' +
                      bookingNumber +
                      '/' +
                      filenames[Number(index)]
                    "
                  >
                    <button
                      class="btn btn-support btn-consultant m-auto btn-secondary"
                    >
                      <i class="material-icons">&#xE880;</i>View Document
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small
            >This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
import { mapGetters } from "vuex";
import { getSite } from "@/lib/utilities";
export default {
  data() {
    return {
      payload: {},
      filenames: [],
      supplier: "",
    };
  },
  methods: {
    async showModal(payload) {
      this.$refs["additional-document-modal-ref"].show();
      this.payload = payload;
      this.supplier = payload.supplier;
      this.filenames =
        payload.flag === "multi"
          ? payload.docIndexes.map(
              (index) => payload.message[0].filenames[index]
            )
          : payload.message[0].filenames;
    },
    async openVoucher(filename) {
      const newWindow = window.open("", "_new");

      newWindow.location =
        "https://www.trailfinders.com/travel-vouchers/" +
        this.directory +
        "/" +
        filename;
    },
    closeModal() {
      this.$refs["additional-document-modal-ref"].hide();
    },
  },
  computed: {
    ...mapGetters({
      additionalSupDocGroups: "booking/getAdditionalSupDocGroups",
    }),
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
    bookingNumber() {
      return this.$store.getters["booking/getBookingNumber"];
    },
    returnSite() {
      return getSite();
    },
  },
  filters: {
    replaceFilename: (value) => {
      if (value) {
        value = value.replace(/_/g, " ");
        value = value.substring(0, value.indexOf("."));
        return value;
      }
      return "";
    },
  },
};
</script>
<style lang="scss">
@import "./style.scss";
.message {
  margin-bottom: 20px;
}
</style>
